// Generated by scripts/update-seeq-icons.js from src/svg/seeq/analysis-lock.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcAnalysisLock = {
  prefix: 'fak',
  iconName: 'analysis-lock' as IconName,
  icon: [
    1471,
    1024,
    [],
    'f957',
    'M1413 285.2h-136.1c-25.3 0-47.1 15.7-54.9 40.1l-117.8 356.8-109-633.3c-5.2-27.9-28.8-48-57.6-47.9h-135.1c-27 0-51.5 19.2-56.7 46.2l-64.6 304.4h-35.7c13.1 36.6 21.8 75 22.6 116h60.2c27 0 51.5-19.2 56.7-46.2l64.6-304.4h39.2l110.8 641.1c5.2 27.9 28.8 48 57.5 47.9h87.3c25.3 0 47.1-15.7 54.9-40.1l120.4-363.7h94.2c32.3 0 58.4-26.2 58.4-58.4s-26.2-58.4-58.4-58.5h-0.9zM522.5 1024c48 0 86.4-38.4 86.3-86.4v-299.1c0-35.8-21.8-66.3-52.3-79.4v-83.7c0-138.7-113.4-252.1-252.1-252.1s-252.1 113.4-252.1 252.1v83.7c-30.5 13.1-52.3 43.6-52.3 79.4v299.1c0 48 38.4 86.4 86.4 86.4h436.1zM168.3 475.4c0-75 61.1-136.1 136.1-136.1s136.1 61.1 136.1 136.1v76.7h-272.2v-76.7z',
  ],
} satisfies IconDefinition;
